<section class="flex justify-content-center mt-4">
    <div class="card-table col-12 flex flex-column">
        <div >
            <CustomTitle [title]="'components.app-correo-plantilla.title-table' | translate" [showTag]="false"
                         [styleClass]="'font-principal app-title-page-color font-medium font-23 text-uppercase mt-4 '"/>
        </div>
        <custom-table [config]="customTable" (emitterLazyLoad)="lazyloadRecords($event)">
        </custom-table>
    </div>
</section>

<p-dialog [closable]="true" appendTo="body" [header]="title()" draggable="false"
          [breakpoints]="{'2000px': '75vw', '1900px': '75vw', '1700px': '75vw',
           '1400px': '85vw', '960px': '90vw', '640px': '95vw'}" (onHide)="closeModal()"
          [modal]="true" [(visible)]="showTemplate">
    <p-tabView [(activeIndex)]="activeTabIndex">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="flex gap-1 align-items-center">
                        <span>
                            {{title()}}
                        </span>
                </div>
            </ng-template>
            <form [formGroup]="form" class="grid bg-white p-3" (ngSubmit)="createOrUpdateTemplate()"
                  (keydown.enter)="$event.preventDefault()">

                <div class="col-12 md:col-6">
                    <label for="nombre">{{ translations?.name }}</label>
                    <input type="text" id="nombre" name="nombre" placeholder="Nombre"
                           formControlName="nombre"
                           pInputText class="w-full p-2 border border-gray-300 ">
                    @if (form.get('nombre')?.invalid && form.get('nombre')?.touched) {
                        <app-form-group-error-message [control]="form.get('nombre')"/>
                    }

                </div>

                <div class="col-12 md:col-6">
                    <label class="block"
                           for="description">{{ translations?.description }}</label>
                    <textarea id="description" name="description" autoResize="false" rows="4" class="w-full"
                              pInputTextarea formControlName="description"
                              [placeholder]="translations?.description"></textarea>
                    @if (form.get('description')?.invalid && form.get('description')?.touched) {
                        <app-form-group-error-message [control]="form.get('description')"/>
                    }

                </div>
                <div class="col-12 grid ">
                    <label class="col-12" for="editor">{{ translations?.content }}</label>
                  <p-messages [value]="messages" enableService="false" styleClass="ml-2"/>
                    <div class="col-12 md:col-3 border-1 border-gray-400 my-2 border-round-lg ml-2">
                        <p-table [value]="variables" scrollHeight="250px"
                                 [scrollable]="true" [(selection)]="variableSelected"
                                 [globalFilterFields]="['description']" (onRowSelect)="selectionItem($event)"
                                 selectionMode="single">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th colspan="2">
                                        {{ translations?.headerVariable }}
                                    </th>
                                </tr>
                                <tr>
                                  <th class="flex justify-content-between">
                                    <input pInputText type="text" [(ngModel)]="variable"
                                           (keydown)="blockSpace($event)"
                                             [ngModelOptions]="{standalone:true}" (keyup.enter)="addVariable()"
                                           [placeholder]="translations?.placeholderAgregar">
                                  </th>
                                  <th>
                                    <button pButton  class="p-button-outlined" type="button"
                                            icon="pi pi-plus" (click)="addVariable()"></button>
                                  </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-index="rowIndex">
                                <tr [pSelectableRow]="item">
                                    <td>{{ item }}</td>
                                    <td>
                                      <button pButton icon="pi pi-times" class="p-button-outlined p-button-danger"
                                              (click)="deleteVariable( index)"></button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <div class="col-12 md:col lg:col">
                        <div class="block">
                            <p-contextMenu [model]="modelContextMenu" appendTo="body"/>
                            <quill-editor formControlName="template" [theme]="'snow'" [class]="'w-full'"
                                          #editorHtml
                                           (onEditorCreated)="onEditorCreated($event)"
                                           (contextmenu)="onContextMenu($event)"
                                          [modules]="quillConfig"
                                          (onContentChanged)="onChangeContent($event.html)"
                                          [placeholder]="translations?.placeholderContent"
                                          id="editor" [style]="{ height: '240px' }"/>

                        </div>
                        @if (form.get('template')?.invalid && form.get('template')?.touched) {
                            <app-form-group-error-message [control]="form.get('template')"/>
                        }

                    </div>
                </div>
                <p-divider/>

                <div class="col-12 flex justify-content-center mt-3">
                    <button type="submit" pButton label="Guardar plantilla" [disabled]="form.invalid"
                            class="btn btn-primary btn-lg btn-block"></button>
                </div>
            </form>
        </p-tabPanel>
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="flex gap-1 align-items-center">
                        <span>
                          {{translations?.preview}}
                        </span>
                </div>
            </ng-template>
            <div class="grid">
                <div class="col-12  border-1 border-gray-400 my-2 border-round-lg wrapper-preview">
                    <div class="p-3 content-preview"
                         [innerHtml]="templateHtml | safeResource : 'html'"></div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>
</p-dialog>






<p-toast life="5_000" key="confirm" position="bottom-center"/>

